/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  DeleteApiV1SerieIdMutationResponse,
  DeleteApiV1SerieIdPathParams,
  DeleteApiV1SerieId401,
  DeleteApiV1SerieId404,
  DeleteApiV1SerieId500,
} from "../../types/serieRegistroController/DeleteApiV1SerieId.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { deleteApiV1SerieId } from "../../clients/serieRegistroController/deleteApiV1SerieId.ts";

export const deleteApiV1SerieIdMutationKey = () =>
  [{ url: "/api/v1/serie/:id" }] as const;

export type DeleteApiV1SerieIdMutationKey = ReturnType<
  typeof deleteApiV1SerieIdMutationKey
>;

export function deleteApiV1SerieIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = deleteApiV1SerieIdMutationKey();
  return mutationOptions<
    DeleteApiV1SerieIdMutationResponse,
    ResponseErrorConfig<
      DeleteApiV1SerieId401 | DeleteApiV1SerieId404 | DeleteApiV1SerieId500
    >,
    { id: DeleteApiV1SerieIdPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteApiV1SerieId(id, config);
    },
  });
}

/**
 * @description Exclusão física da série e de tudo relacionado (idiomas, turmas, vídeos e idiomas dos vídeos). **(Requer Authorization para autenticação)**
 * @summary Excluir série (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:id}
 */
export function useDeleteApiV1SerieId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiV1SerieIdMutationResponse,
      ResponseErrorConfig<
        DeleteApiV1SerieId401 | DeleteApiV1SerieId404 | DeleteApiV1SerieId500
      >,
      { id: DeleteApiV1SerieIdPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiV1SerieIdMutationKey();

  const baseOptions = deleteApiV1SerieIdMutationOptions(
    config,
  ) as UseMutationOptions<
    DeleteApiV1SerieIdMutationResponse,
    ResponseErrorConfig<
      DeleteApiV1SerieId401 | DeleteApiV1SerieId404 | DeleteApiV1SerieId500
    >,
    { id: DeleteApiV1SerieIdPathParams["id"] },
    TContext
  >;

  return useMutation<
    DeleteApiV1SerieIdMutationResponse,
    ResponseErrorConfig<
      DeleteApiV1SerieId401 | DeleteApiV1SerieId404 | DeleteApiV1SerieId500
    >,
    { id: DeleteApiV1SerieIdPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteApiV1SerieIdMutationResponse,
    ResponseErrorConfig<
      DeleteApiV1SerieId401 | DeleteApiV1SerieId404 | DeleteApiV1SerieId500
    >,
    { id: DeleteApiV1SerieIdPathParams["id"] },
    TContext
  >;
}
